import React from 'react';
import PageTransition from '../components/PageTransition';
import './LegalPages.css';

function TermsOfServicePage() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Terms of Service</h1>
                <p className="effective-date">Last Updated: 24/2/2026</p>

                <section className="legal-section">
                    <p>By accessing <a href="https://www.iswaran.com/">https://www.iswaran.com/</a>, you agree to the following terms:</p>
                </section>

                <section className="legal-section">
                    <h2>Nature of Service</h2>
                    <p>Iswaran acts as a facilitator. We are not the official representatives of the temples listed. Our service includes appointing a representative to perform rituals in your name and delivering the resulting Prasadam to your location.</p>
                </section>

                <section className="legal-section">
                    <h2>User Responsibility</h2>
                    <p>You are responsible for providing accurate birth and lineage details (Gothra/Nakshatra). Iswaran is not liable for rituals performed with incorrect data provided by the user.</p>
                </section>

                <section className="legal-section">
                    <h2>Service Variations</h2>
                    <p>Ritual timings may vary based on temple schedules, festivals, or unforeseen closures. We strive to complete all services within the promised timeline.</p>
                </section>

                <section className="legal-section">
                    <h2>Intellectual Property</h2>
                    <p>All content, logos, and designs on this website are the property of Iswaran and may not be used without prior written consent.</p>
                </section>

                <section className="legal-section">
                    <h2>Contact Address</h2>
                    <address className="contact-info">
                        Joseph snowin S,<br />
                        No 130,<br />
                        Church road,<br />
                        Pallavan nagar, Old Pallavaram,<br />
                        Kancheepuram, Tamil Nadu, 600117 <br/>
                        iswarandivine@gmail.com
                    </address>
                </section>
                    
            </div>
        </div>
    );
}

export default PageTransition(TermsOfServicePage);
